import React from 'react';
import { FadeIn } from './FadeIn';
export function Problems() {
  const problems = [{
    image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    title: '¿Miedo al dentista?',
    description: 'Transformamos la ansiedad en tranquilidad. Utilizamos técnicas de sedación consciente y un ambiente relajante con aromaterapia y música para que tu visita sea un placer.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/1T2VkhXzumQ7mxA3jACW5K/Imagen_1.jpg',
    title: 'Tecnología Sin Dolor',
    description: 'Olvídate de las molestias. Nuestra clínica está equipada con anestesia computarizada y láser dental de última generación para tratamientos rápidos y 100% indoloros.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/gBMhtxgnqmEbBVMjRUvm92/Imagen_2.jpg',
    title: 'Inseguridad al Sonreír',
    description: 'Recupera tu confianza. Diseñamos sonrisas perfectas que armonizan con tu rostro, mejorando no solo tu estética sino tu autoestima y calidad de vida.'
  }];
  return <section className="py-24 relative z-10" data-id="element-158">
      <div className="max-w-7xl mx-auto px-6" data-id="element-159">
        <FadeIn className="text-center max-w-2xl mx-auto mb-16" data-id="element-160">
          <h2 className="text-4xl md:text-5xl font-black text-nova-dark mb-6 tracking-tight" data-id="element-161">
            Entendemos tus preocupaciones
          </h2>
          <p className="text-lg text-nova-gray" data-id="element-162">
            Hemos rediseñado por completo la experiencia odontológica para
            eliminar todo lo que no te gusta de ir al dentista.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-163">
          {problems.map((problem, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-164">
              <div className="group relative overflow-hidden rounded-3xl min-h-[420px] flex flex-col justify-end hover:-translate-y-2 transition-transform duration-300 shadow-glass" data-id="element-165">
                {/* Background Image */}
                <div className="absolute inset-0 z-0" data-id="element-166">
                  <img src={problem.image} alt={problem.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-167" />
                  <div className="absolute inset-0 bg-gradient-to-t from-nova-dark/90 via-nova-dark/50 to-nova-dark/10" data-id="element-168"></div>
                </div>
                {/* Content */}
                <div className="relative z-10 p-8" data-id="element-169">
                  <h3 className="text-2xl font-bold text-white mb-3" data-id="element-170">
                    {problem.title}
                  </h3>
                  <p className="text-gray-200 leading-relaxed text-sm" data-id="element-171">
                    {problem.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}